<template>
  <!--  条目Item  -->
  <div :class="is_lock_infeed?'footer_div':'footer_div_can_scol'" >
    <el-row :gutter="0">
      <el-col :span="18">
        <div class="grid-content bg-purple info_div">
          <p class="info_font_tse">
            <el-menu
              :default-active="activeIndex"
              text-color="#eeeeee"
              active-text-color="#E71489"
              class="el-menu-demo menu-div"
              mode="horizontal"
              @select="handleSelect">
              <el-menu-item index="1">关于我们</el-menu-item>
              <el-menu-item index="2">项目案例</el-menu-item>
              <el-menu-item index="3">合作申请</el-menu-item>
              <el-menu-item index="4">资料下载</el-menu-item>
              <el-menu-item index="5">视频资料</el-menu-item>
            </el-menu>
          </p>
          <p class="info_font">Copyright@ 2022 www.taimaker.com All Rights Reserved.  <a class="info_font" href="https://beian.miit.gov.cn/" target="_blank">{{getIcpInfo()}}</a></p>
        </div>
      </el-col>
      <!--三个二维码-->
      <el-col :span="5">
        <div class="grid-content bg-purple ">
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <img class="qr_img" src="../assets/test_qr_code_01.png">
                <br><label class="qr_font">关注钛创星</label>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <img class="qr_img" src="../assets/test_qr_code_02.png">
                <br><label class="qr_font">了解咨询</label>
              </div>
            </el-col>
            <!--三个二维码-->
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <img class="qr_img" src="../assets/test_qr_code_03.png">
                <br><label class="qr_font">视频号</label>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    is_lock_infeed: {    //是否锁定底部
      type: Boolean,
      require: false,
      default: false
    },
    activeIndex: {
      type: String,
      require: false,
      default: ''
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      if (key == '1') {  //关于我们
        this.$router.push({path: '/about'})
      } else if (key == '2') {   //项目案例
        this.$router.push({path: '/project'})
      } else if (key == '3') {   //合作申请
        this.$router.push({path: '/cooperate'})
      } else if (key == '4') {   //资料下载
        this.$router.push({path: '/means'})
      }else if (key == '5') {   //视频资料
        this.$router.push({path: '/video'})
      }
    },
    getIcpInfo() {
      let sitename = location.hostname
      if (sitename.includes('taimaker.com') || sitename.includes('taimaker.cn')) {
        return '沪ICP备16051044号-1'
      }

      if (sitename.includes('taistar.cn')) {
        return '沪ICP备16051044号-2'
      }

      return '未知的ICP备案号'
    }
  }
}
</script>

<style scoped lang="scss">

/deep/ .el-menu.el-menu--horizontal {
  border-bottom: solid 0px #ffffff;
}

/deep/ .el-menu {
  border-right: solid 0px #ffffff;
  list-style: none;
  position: relative;
  margin: 0;
  padding-left: 0;
  height: 50px;
  background-color: rgba(255, 255, 255, 0);
}

/deep/ .el-menu-item {
  font-size: 16px;
  color: #303133;
  padding: 0 20px;
  cursor: pointer;
  -webkit-transition: border-color .3s, background-color .3s, color .3s;
  transition: border-color .3s, background-color .3s, color .3s;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: left;
}

/deep/ .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover, .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: rgba(255, 255, 255, 0);
}

/deep/ .el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 0px solid #409EFF;
  color: #303133;
}

/deep/ .el-menu--horizontal > .el-menu-item {
  float: left;
  height: 40px;
  line-height: 40px;
  margin: 0;
  border-bottom: 0px solid transparent;
  color: #909399;
}

.menu-div {
  margin-top: 18px;
  font-size: 18px;
  font-weight: 300;
}

.footer_div {
  width: 100%;
  height: 120px;
  background-color: #fff;
  position: absolute;
  z-index: 100000;
  bottom: 0px;
  background-color: rgba(255, 255, 255, 0); /*背景透明*/
  min-width: 1220px;
}

.footer_div_can_scol { //可以滑动
  margin-top: 80px;
  width: 100%;
  height: 120px;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0); /*背景透明*/
  min-width: 1220px;
}

.qr_img {
  width: 86%;
  height: auto;
}

.qr_font {
  font-size: 12px;
  color: #ffffff;
}

.info_font {
  font-size: 15px;
  color: #ffffff;
  padding-left: 15px;
  font-weight: 300;
}

.info_font_sys {
  bottom: 0px;
  position: absolute;
  z-index: 999;
  font-size: 15px;
  color: #ffffff;
  padding-left: 15px;
  width: 95%;
  line-height: 40px;
  text-align: center;
}

.info_div {
  text-align: left;
  padding-left: 30px;
}

.info_font_tse {
  font-size: 16px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue